import React from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { useTranslation } from "react-i18next";
import createPersistedState from "use-persisted-state";
const useClinicState = createPersistedState("clinic");

function AppointmentListItem({
  upcomingAppt,
  onReschedule,
  setSelectedAppt,
  setAttendDetail,
  setId,
}) {
  let history = useHistory();
  const { t } = useTranslation();
  const [clinicId, setClinic] = useClinicState();

  return (
    <div className="box_view_app">
      <div className="head_view d-flex justify-content-between align-items-center">
        <span className="txt_normal">
          {/* {t("appointment.CONFIRMED.doctor-name")} */}
          {upcomingAppt?.ownerMetadata?.name}
        </span>
        <span className="txt_small">
          {upcomingAppt?.ownerMetadata?.code.slice(0, 2) == "DR"
            ? t("appointment.DOCTOR.doctor1")
            : t("appointment.DOCTOR.doctor2")}
        </span>
      </div>
      <span className="txt_normal">{upcomingAppt?.startTime}</span>
      <span className="txt_normal">
        {moment(new Date(upcomingAppt?.date)).format("DD MMMM YYYY, dddd")}
      </span>
      <span className="txt_normal">
        {upcomingAppt?.online
          ? t("appointment.CLINIC.clinic0")
          : upcomingAppt?.spaceMetadata?.name}
      </span>
      {upcomingAppt.hasOwnProperty("attendeeStatus") &&
        upcomingAppt["attendeeStatus"] !== "Arrived" && (
          <div className="btn_block  d-flex align-items-center justify-content-center">
            <button
              className="btn btn_outline"
              data-bs-toggle="modal"
              data-bs-target="#modal_appcancel"
              onClick={() => {
                setSelectedAppt(upcomingAppt);
                setAttendDetail(upcomingAppt);
                setId(upcomingAppt.id);
              }}
            >
              {t("appointment.BUTTON.cancel")}
            </button>
            <button
              className="btn btn_outline"
              onClick={() => {
                setSelectedAppt(upcomingAppt);
                setAttendDetail(upcomingAppt);
                setId(upcomingAppt.id);
                onReschedule(upcomingAppt);
              }}
            >
              {t("appointment.BUTTON.reschedule")}
            </button>
          </div>
        )}
    </div>
  );
}

export default AppointmentListItem;
